import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConnectivityService } from 'app/core/connectivity/connectivity.service';
import { isConnectivityStatus } from 'app/shared/utils/app-error-utils';
import { tap } from 'rxjs';

export const connectivityInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
) => {
    const connectivityService = inject(ConnectivityService);

    return next(req).pipe(
        tap({
            error: (error: unknown) => {
                if (req.method !== 'GET' || !req.url.startsWith('api/')) {
                    return;
                }
                if (error instanceof HttpErrorResponse
                    && (error.error instanceof ErrorEvent || isConnectivityStatus(error.status))) {
                    connectivityService.notifyUnavailable();
                }
            }
        })
    );
};
